import { useCombineSelector, useDelayEffect } from './hooks';
import { REDUCER_NAME, WalletModel, WalletTransactionModel } from '@reducers/wallet';
import { useCallback, useState } from 'react';
import { SupportChains } from '@/config/constants';
import ContractConstants from '@/services/contract.constants';
import { Config, signMessage } from '@web3-onboard/wagmi';
import { waitUntil } from '@/utils';
import { ContextTokens } from './reducers/token';
import { WalletState } from '@web3-onboard/core';
import { useConnectWallet, useWagmiConfig } from '@web3-onboard/react';
declare type SignResult = { signMessage: string; address: string };

export const WalletContext: WalletContextModel = {
    Provider: null,
    Address: '',
    Wallet: undefined,
    Onboard: undefined,
    Chain: undefined,
};

export interface UseWalletModal extends WalletTransactionModel {
    chainName: string;
    wallet: WalletState | null;
    wagmiConfig: Config | null;
    accountChanged: number;
}

export const useWallet = (): UseWalletModal => {
    const config = useWagmiConfig();
    const [accountChanged, setAccountChanged] = useState(0);
    const [{ wallet }] = useConnectWallet();
    const account: WalletTransactionModel = useCombineSelector<WalletTransactionModel>(REDUCER_NAME, (state) => state);
    useDelayEffect(() => setAccountChanged((c) => c + 1), [account.address, account.type, account.chainId, account.connected, account.logged]);
    return {
        ...account,
        accountChanged,
        wallet,
        wagmiConfig: config,
        chainName: account.chain ? account.chain.name : '',
    };
};

/**
 * create a sign callback
 * @returns
 */
export const useSignCallback = (): ((message: string) => Promise<SignResult>) => {
    const { address, chainId, wallet, wagmiConfig } = useWallet();
    return useCallback(
        async (message: string) => {
            if (!wallet) throw new Error('wallet unconnection.');
            if (!wagmiConfig) throw new Error('sign error: wagmi config is null.');
            const mg = await signMessage(wagmiConfig, {
                message: message,
                connector: wallet.wagmiConnector,
            });
            return { signMessage: mg, address: address };
        },
        [address, chainId, wagmiConfig, wallet]
    );
};

/**
 * 获取资产信息和账号信息
 */
export const GetCurrencies = async function (): Promise<AicadeCurrencies> {
    const currencies = {} as AicadeCurrencies;
    await waitUntil(() => {
        if (!WalletContext.Chain) return false;
        const chain = SupportChains.filter((o) => o.chainId == WalletContext.Chain?.chainId)[0];
        const tokens = ContextTokens[chain.name];
        currencies.daoToken = tokens[ContractConstants.Names.AGDToken];
        currencies.scoreToken = tokens[ContractConstants.Names.AGSToken];
        currencies.chainName = chain.name;
        return !!currencies.daoToken && !!currencies.scoreToken;
    });

    return currencies;
};
